import React from "react";
import { Rocket } from "lucide-react";

export const Footer = ({ onNav }) => (
  <footer className="border-t border-white/10 bg-[#05070b] px-4 sm:px-6 lg:px-8 py-12 mt-8">
    <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:items-end justify-between gap-8">
      <div>
        <div className="flex items-center gap-2">
          <span className="grid place-items-center h-9 w-9 rounded-lg bg-gradient-to-br from-[#00ff66] to-[#00f0ff] text-black">
            <Rocket size={18} strokeWidth={2.6} />
          </span>
          <span className="font-display font-black text-2xl tracking-tighter">
            SEND<span className="neon-underline">IT</span>
          </span>
        </div>
        <p className="text-slate-400 mt-3 max-w-sm">
          The community decides what gets sent.
        </p>
        <p className="text-xs text-slate-600 mt-4 max-w-md">
          Trending data via DexScreener. SEND IT is a community experiment, not
          financial advice. Ape responsibly.
        </p>
      </div>

      <nav className="flex flex-wrap gap-x-8 gap-y-3">
        {[
          ["how", "How It Works"],
          ["community", "Community"],
          ["terms", "Terms"],
          ["privacy", "Privacy"],
        ].map(([id, label]) => (
          <button
            key={id}
            data-testid={`footer-link-${id}`}
            onClick={() => onNav(id)}
            className="text-sm font-semibold text-slate-300 hover:text-[#00ff66] transition-colors"
          >
            {label}
          </button>
        ))}
      </nav>
    </div>
    <div className="max-w-7xl mx-auto mt-8 pt-6 border-t border-white/5 text-xs text-slate-600 font-mono-num">
      © {new Date().getFullYear()} SEND IT · Built on Solana vibes
    </div>
  </footer>
);
